/** Intro banner copy keyed by locale (game.intro.*). */
export const INTRO_COPY_BY_LOCALE = Object.freeze({
    en: Object.freeze({
        'game.intro.title': "Let's prospect!",
        'game.intro.subtitle':
            'Enjoy the wait while we run prospecting and score as many points as you can. We will notify you when we are done.\n\n' +
            '\n\nRemember: share your score with your colleagues!',
        'game.intro.go': 'Go',
        'result.viewProspectingResults': 'View prospecting results',
    }),
    es: Object.freeze({
        'game.intro.title': '¡A prospectar!',
        'game.intro.subtitle':
            'Disfruta de la espera mientras realizamos la prospección y acumula el máximo de puntos posibles. Te notificaremos cuando hayamos terminado.\n\n' +
            '\n\nY recuerda: ¡Comparte la puntuación con tus colegas!',
        'game.intro.go': 'Go',
        'result.viewProspectingResults': 'Ver resultados de la prospección',
    }),
});

const SUPPORTED_LOCALES = Object.keys(INTRO_COPY_BY_LOCALE);

/**
 * @param {string} [lang] Two-letter code (e.g. from web4 `getLang()` or `navigator.language`).
 * @returns {'en' | 'es'}
 */
export function getLeadPopLocale(lang) {
    const code = String(lang ?? (typeof navigator !== 'undefined' ? navigator.language : 'en'))
        .trim()
        .slice(0, 2)
        .toLowerCase();
    if (SUPPORTED_LOCALES.includes(code)) {
        return code;
    }
    return 'en';
}

/**
 * @param {string} [lang]
 * @returns {Readonly<Record<string, string>>}
 */
export function getIntroCopy(lang) {
    return INTRO_COPY_BY_LOCALE[getLeadPopLocale(lang)] ?? INTRO_COPY_BY_LOCALE.en;
}

/** @deprecated Alias of getIntroCopy — includes intro + result host-action strings. */
export function getGameCopy(lang) {
    return getIntroCopy(lang);
}
